/** @jsxImportSource @emotion/react */
import css from '@emotion/css/macro'
import { keyframes } from '@emotion/react'
import { useEffect, useRef, useState } from 'react'

const slideOut = keyframes`
  from { transform: translateY(0); opacity: 1; }
  to   { transform: translateY(-100%); opacity: 0; }
`

const slideIn = keyframes`
  from { transform: translateY(100%); opacity: 0; }
  to   { transform: translateY(0); opacity: 1; }
`

const scoreContainer = css`
  position: relative;
  overflow: hidden;
  display: inline-flex;
  align-items: center;
  justify-content: center;
`

const AnimatedScore = ({ value }) => {
  const prevRef = useRef(value)
  const [animating, setAnimating] = useState(false)
  const [displayValue, setDisplayValue] = useState(value)

  useEffect(() => {
    if (value !== prevRef.current) {
      setAnimating(true)
      const timer = setTimeout(() => {
        setDisplayValue(value)
        prevRef.current = value
        setAnimating(false)
      }, 300)
      return () => clearTimeout(timer)
    }
  }, [value])

  return (
    <span css={scoreContainer}>
      <span
        key={displayValue}
        css={
          animating
            ? css`
                animation: ${slideOut} 0.3s ease-in forwards;
              `
            : undefined
        }
      >
        {displayValue}
      </span>
      {animating && (
        <span
          css={css`
            position: absolute;
            animation: ${slideIn} 0.3s ease-out forwards;
          `}
        >
          {value}
        </span>
      )}
    </span>
  )
}

export default AnimatedScore
